/** @format */

import styled from 'styled-components';

export const StyledTrFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  height: 40px;
`;
